import React from "react";

import { SwiperCarousel } from "supercell-frontend-base/src/components/swiper-carousel";
import { CarouselSlide } from "supercell-frontend-base/src/components/swiper-carousel/slide";
import { Grid } from "supercell-frontend-base/src/components/grid";
import { List } from "supercell-frontend-base/src/components/list";
import { ListArticle } from "supercell-frontend-base/src/components/list/article";
import { ContentfulSocialLinks } from "supercell-frontend-base/src/components/contentful-social-links";
import { Tab } from "supercell-frontend-base/src/components/inbox/tab";

import { filterNewsFeed } from "supercell-frontend-base/src/utils/filter-news-feed";
import { filterEntry } from "supercell-frontend-base/src/targeting/targeting";
import { SquadBustersGameParams } from "validation/game-params";
import { useGameParamsContext } from "supercell-frontend-base/src/stores/gameParams";

import styles from "./styles.modules.scss";
import { FullscreenEntryContainer } from "supercell-frontend-base/src/components/fullscreen-entry";

export const NewsView = ({ hideSocialLinks }) => (
    <Tab namespace="news">
        {({ locale, data }) => {
            const { gameParams } =
                useGameParamsContext<SquadBustersGameParams>();

            const filterArticles = (a: InboxArticle) =>
                filterNewsFeed(a) && filterEntry(a, gameParams);

            const filteredSocialLinks = data.socialLinks.filter((l) => {
                if (!hideSocialLinks) {
                    return true;
                }

                if (!l.linkUrl) {
                    return false;
                }

                return !l.linkUrl.includes("discord");
            });

            return (
                <FullscreenEntryContainer
                    entries={data.fullscreenEntries.filter((e) =>
                        filterEntry(e, gameParams),
                    )}
                    tab="news"
                >
                    <div className={`news ${styles.news}`}>
                        <Grid>
                            {data.events && data.events["length"] > 0 ? (
                                <div className={`events ${styles.events}`}>
                                    <SwiperCarousel
                                        locale={locale}
                                        Slide={CarouselSlide}
                                        slides={data.events.filter((e) =>
                                            filterEntry(e, gameParams),
                                        )}
                                    />
                                </div>
                            ) : null}

                            {data.articles ? (
                                <div className={`articles ${styles.articles}`}>
                                    <List
                                        Item={ListArticle}
                                        items={data.articles.filter((e) =>
                                            filterArticles(e),
                                        )}
                                        footer={
                                            <ContentfulSocialLinks
                                                links={filteredSocialLinks}
                                            />
                                        }
                                    />
                                </div>
                            ) : null}
                        </Grid>
                    </div>
                </FullscreenEntryContainer>
            );
        }}
    </Tab>
);
